// Constants for About formulas

import { isRelease261Enabled } from '@/config/release261Features';

// Source sets definitions
export const CURATED_SOURCES_GDA = [
  'CLINGEN',
  'CLINPGX',
  'CLINVAR',
  'GENCC',
  'MGD HUMAN',
  'RGD ORPHANET',
  'PSYGENET',
  'UNIPROT',
];

export const CURATED_SOURCES_VDA = ['CLINGEN', 'CLINPGX', 'CLINVAR', 'GWASCAT', 'PHEWASCAT', 'UNIPROT'];

export const CLINICAL_TRIALS_SOURCES = ['CLINICAL TRIALS'];

const INFERRED_SOURCES_BASE = ['FINNGEN', 'GWASCAT', 'HPO', 'PHEWASCAT', 'UKBIOBANK'] as const;

export const INFERRED_SOURCES = [
  ...INFERRED_SOURCES_BASE,
  ...(isRelease261Enabled ? (['CHEMBL'] as const) : []),
];

const INFERRED_SOURCE_API_IDS_BASE = [
  'INFERRED',
  'FINNGEN',
  'GWASCAT',
  'HPO',
  'PHEWASCAT',
  'UKBIOBANK',
] as const;

export const INFERRED_SOURCE_API_IDS = [
  ...INFERRED_SOURCE_API_IDS_BASE,
  ...(isRelease261Enabled ? (['CHEMBL'] as const) : []),
];

export const RELATION_EXTRACTION_ASSOCIATION_TYPES = [
  'AlteredExpression',
  'Biomarker',
  'CNV',
  'CausalMutation',
  'CellMarker',
  'EpigenomicAlterations',
  'FusionGene',
  'NonCodingRnaRegulation',
  'Other',
  'Pharmacogenomics',
  'PostTranslationalModification',
  'ProtectiveMutation',
  'SusceptibilityMutation',
  'TherapeuticTarget',
] as const;

export const RELATION_EXTRACTION_ASSOCIATION_TYPES_GDA = RELATION_EXTRACTION_ASSOCIATION_TYPES;

export const LEGACY_ASSOCIATION_TYPES_GDA = [
  'CausalOrContributing',
  'ChromosomalRearrangement',
  'DrugResponse',
  'GeneticVariation',
  'GermlineCausalMutation',
  'GermlineModifyingMutation',
  'Phosphorylation',
  'Protective',
  'SomaticCausalMutation',
] as const;

export const ASSOCIATION_TYPES_GDA_PRE_V261 = [
  'AlteredExpression',
  'Biomarker',
  'CausalMutation',
  'CausalOrContributing',
  'CellMarker',
  'ChromosomalRearrangement',
  'DrugResponse',
  'EpigenomicAlterations',
  'FusionGene',
  'GeneticVariation',
  'GermlineCausalMutation',
  'GermlineModifyingMutation',
  'Pharmacogenomics',
  'Phosphorylation',
  'PostTranslationalModification',
  'Protective',
  'SomaticCausalMutation',
  'SusceptibilityMutation',
] as const;

export const ASSOCIATION_TYPES_GDA = isRelease261Enabled
  ? [...RELATION_EXTRACTION_ASSOCIATION_TYPES, ...LEGACY_ASSOCIATION_TYPES_GDA]
  : [...ASSOCIATION_TYPES_GDA_PRE_V261];

export const LEGACY_ASSOCIATION_TYPES_VDA = [
  'DrugResponse',
  'GeneticVariation',
  'Protective',
  'VUS',
] as const;

export const ASSOCIATION_TYPES_VDA_PRE_V261 = [
  'CausalMutation',
  'DrugResponse',
  'GeneticVariation',
  'Pharmacogenomics',
  'Protective',
  'SusceptibilityMutation',
  'VUS',
] as const;

export const ASSOCIATION_TYPES_VDA = isRelease261Enabled
  ? [...RELATION_EXTRACTION_ASSOCIATION_TYPES, ...LEGACY_ASSOCIATION_TYPES_VDA]
  : [...ASSOCIATION_TYPES_VDA_PRE_V261];

export const MODELS_SOURCES = ['MGD MOUSE', 'RGD RAT', 'TEXTMINING MODELS'];

export const LITERATURE_SOURCES = ['TEXTMINING HUMAN', 'TEXTMINING MODELS'];

export const LITERATURE_SOURCES_VDA = ['TEXTMINING HUMAN'];

export const BIOBANK_SOURCES = ['FINNGEN', 'UKBIOBANK'];

// Common MathML namespace
export const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
